module.exports = __webpack_public_path__ + "static/lighthouse-3a739334b8a3a581ffdfb1de0fcf77e2.mp4";